<template>
    <div :id="elemId" class="bng-quick-login-reg" v-if="!isLoggedIn">
        <div class="tabs is-boxed is-small">
            <ul>
                <li @click="tab='login'" :class="{'is-active': tab=='login'}">
                    <a>{{'components.common.quick-login-reg.tabs.login' | translate}}</a>
                </li>
                <li @click="tab='registration'" :class="{'is-active': tab=='registration'}">
                    <a>{{'components.common.quick-login-reg.tabs.registration' | translate}}</a>
                </li>
            </ul>
        </div>
        <div class="tab-content" v-show="tab=='login'">
            <login />
        </div>
        <div class="tab-content" v-show="tab=='registration'">
            <registration />
        </div>
    </div>
</template>
<script>
import Vue from 'vue';

import Login from './login.vue';
import Registration from './registration.vue';

export default {
    name: 'quick-login-reg',
    components: {
        Login,
        Registration
    },
    props: {
        elemId: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            tab: 'login',
            registrationStep: 1,
            options: {
                arrows: false,
                autoplay: true,
                autoplaySpeed: 3000
            }
        };
    },
    computed: {
        isLoggedIn() {
            return Vue.state.player.isLoggedIn();
        },
        player() {
            return Vue.state.player.get();
        },
        client() {
            return Vue.state.client.get();
        },
        categories() {
            return Vue.state.games.get().categories;
        },
        registrationTabs() {
            let defaultRegistrationType = this.client.registration.defaultRegistrationType || this.client.registration.registrationTypes[0];
            let q = registrationTypes
                .filter(registrationType => this.client.registration.registrationTypes.some(type => type === registrationType.type))
                .sort((a, b) => (a.type == defaultRegistrationType ? -1 : ('' + a.type.attr).localeCompare(b.type.attr)));

            return q;
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/quick-login-reg/quick-login-reg.vue